module.exports = __webpack_public_path__ + "static/cely_rose_grossesse_2-2fb91388c3652937b6857ca094c8437c.jpg";